import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
var _excluded = ["value", "onChange", "formFileInformation", "componentKey", "formDataDecisions", "isSaving", "label", "notice", "required", "onEvent"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.promise.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { P, match } from 'ts-pattern';
import { ErrorBoundary } from 'react-error-boundary';
import { ZodError } from 'zod';
import { Box, Button, Checkbox, CheckboxGroup, Combobox, createForm, FileUpload, Flex, HelpText, Link, Notice, NumberInput, ProgressIndicator, RadioGroup, Select, Textarea, TextInput, Text, validateFiles, FileList, useId, Overlay } from '@applyboard/crystal-ui';
import { ArrowLeftOutlineIcon, ArrowRightOutlineIcon, CheckMarkOutlineIcon } from '@applyboard/ui-icons';
import { emptyObject, useQuery, useTranslation, useDebouncedState } from '@applyboard/ui-utils';
import { buildConditionalLogicDependencyGraph, getConditionalLogicDirectDependencies, decideShouldShowField, calculateOtherFieldValueUpdates, getComponentPage, copyFormDataOntoFormDefinition, calculateInitialDefaultValues, parseFormDef, isEmptyValue, isFileInfo, checkAreAnyFieldsVisible, getNextPageWithVisibleFields, getPrevPageWithVisibleFields, validateFormDataAgainstFormDefinition, isFieldComponent, getComponentKeys, checkIsSinglePaymentFrame } from "./DynamicForm.utils";
import { DynamicFormPreview } from "./DynamicFormPreview";
import { Markdown } from "../Markdown";
import { ErrorFallback } from "../ErrorFallback";
import { TimelessDateStringInput } from "../TimelessDateStringInput";
import { PaymentPrompt } from "./customComponents/PaymentPrompt";
import { PaymentFrame, PaymentFrameProvider, useResetPaymentFrame, usePaymentStatus } from "./customComponents/PaymentFrame";
import { LightBulbAndGearsIllustration } from "../../illustrations";
import { useContextOrThrow, useNow } from "../../utils/hooks";
import { differenceInSeconds } from 'date-fns';
import { assert } from "../../utils/assert";
import { isArray } from "../../utils/isArray";
import { get, isEqual, omit, uniq } from 'lodash';
import { Mustache } from "../../utils/mustache";
import { unstable_batchedUpdates as batch } from 'react-dom';

/**
 * These are the possible events sent by the onEvent callback below
 */
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var _createForm = createForm({
    provider: true
  }),
  FormProvider = _createForm.FormProvider,
  Form = _createForm.Form,
  Field = _createForm.Field,
  useFieldValues = _createForm.useFieldValues,
  useSetFieldValues = _createForm.useSetFieldValues,
  useGetFieldValues = _createForm.useGetFieldValues,
  useTriggerValidation = _createForm.useTriggerValidation,
  useResetFormValues = _createForm.useResetForm;

/**
 * `DynamicForm` is AP's form rendering engine.  It takes a formDefinition and
 * dynamically renders a form based off this definition using crystal-ui
 * components.
 *
 * The formDefinition is compliant with the data structure that `form.io` uses.
 * This means it's compatible with the `form.io` builder.
 *
 * It powers several features, including hybrid requirements and the road runner
 * dashboard
 */
export function DynamicForm(props) {
  return _jsx(ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref) {
      var error = _ref.error;
      return _jsx(ErrorFallback, {
        message: "An error occurred while trying to display this form. (Error code: ".concat(getErrorCodeFromError(error), ")"),
        error: error
      });
    },
    children: _jsx(DynamicFormContent, _objectSpread({}, props))
  });
}
function getErrorCodeFromError(error) {
  if (error instanceof Error && error.toString().includes('Maximum call stack size exceeded')) {
    return "error_infinite_loop";
  }
  if (error instanceof ZodError) {
    return "error_schema_validation";
  }
  return "error_unknown";
}

/**
 * Gets the initial page that will be the page of first rejected answer, otherwise 1
 */
function getInitialPageToDisplay(components, formDataDecisions) {
  var _rejectedField$proper;
  var sortedComponents = _toConsumableArray(components).sort(function (a, b) {
    var _a$properties, _b$properties;
    var pageA = a !== null && a !== void 0 && (_a$properties = a.properties) !== null && _a$properties !== void 0 && _a$properties.page ? Number(a.properties.page) : 1;
    var pageB = b !== null && b !== void 0 && (_b$properties = b.properties) !== null && _b$properties !== void 0 && _b$properties.page ? Number(b.properties.page) : 1;
    return pageA - pageB;
  });
  var rejectedField = sortedComponents.find(function (formField) {
    var data = formDataDecisions && formDataDecisions[formField.key];
    if (!data) {
      return false;
    }
    return data.some(function (decision) {
      return decision.status === 'rejected';
    });
  });
  return Number(rejectedField === null || rejectedField === void 0 ? void 0 : (_rejectedField$proper = rejectedField.properties) === null || _rejectedField$proper === void 0 ? void 0 : _rejectedField$proper.page) || 1;
}
var DynamicFormContext = /*#__PURE__*/createContext(null);
function DynamicFormContent(_ref2) {
  var formDefinition = _ref2.formDefinition,
    _ref2$formData = _ref2.formData,
    formData = _ref2$formData === void 0 ? emptyObject : _ref2$formData,
    formDataDecisions = _ref2.formDataDecisions,
    formId = _ref2.formId,
    ariaLabel = _ref2['aria-label'],
    ariaLabelledBy = _ref2['aria-labelledby'],
    uploadFile = _ref2.uploadFile,
    formFileInformation = _ref2.formFileInformation,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur,
    _onSubmit = _ref2.onSubmit,
    debug = _ref2.debug,
    hideFormInstructions = _ref2.hideFormInstructions,
    hideFormActions = _ref2.hideFormActions,
    validationNoticeText = _ref2.validationNoticeText,
    isSaving = _ref2.isSaving,
    onAttemptNextWhileVerifying = _ref2.onAttemptNextWhileVerifying,
    onRequestConfirmPayment = _ref2.onRequestConfirmPayment,
    onRequestCreateOrder = _ref2.onRequestCreateOrder,
    onClose = _ref2.onClose,
    onEvent = _ref2.onEvent,
    children = _ref2.children,
    blockProceedWhenMissingFileInfo = _ref2.blockProceedWhenMissingFileInfo,
    initialFormMetadata = _ref2.formMetadata,
    request = _ref2.request,
    disabled = _ref2.disabled;
  var context = useContext(DynamicFormContext);
  assert(!context, 'Can not nest DynamicForm components');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showVerificationOverlayIfNeeded = _useState2[0],
    setShowVerificationOverlayIfNeeded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showValidationNotice = _useState4[0],
    setShowValidationNotice = _useState4[1];
  var parsedFormDef = useMemo(function () {
    return parseFormDef(formDefinition);
  }, [formDefinition]);
  var dependencyGraph = useMemo(function () {
    return buildConditionalLogicDependencyGraph(parsedFormDef);
  }, [parsedFormDef]);
  var finalFormDef = useMemo(function () {
    return copyFormDataOntoFormDefinition(parsedFormDef, formData);
  }, [parsedFormDef, formData]);
  var defaultValues = useMemo(function () {
    return calculateInitialDefaultValues({
      formDefinition: finalFormDef,
      dependencyGraph: dependencyGraph
    });
  }, [finalFormDef, dependencyGraph]);

  // initialize the currentPage to be the first page of the form that has a rejected answer or 1 if no rejected answers
  var _useState5 = useState(getInitialPageToDisplay(parsedFormDef.components, formDataDecisions)),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPage = _useState6[0],
    setCurrentPage = _useState6[1];
  var defaultFormId = useId();
  var _useState7 = useState(initialFormMetadata || {}),
    _useState8 = _slicedToArray(_useState7, 2),
    formMetadata = _useState8[0],
    setFormMetadata = _useState8[1];
  return _jsx(FormProvider, {
    defaultValues: defaultValues,
    onSubmit: function onSubmit(values, _ref3) {
      var _setValues = _ref3.setValues;
      setShowValidationNotice(false);
      var processedValues = processFormDataForSubmit({
        formDefinition: parsedFormDef,
        formData: values
      });
      _onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit(processedValues, {
        metadata: formMetadata,
        // In some cases the BE will update the form_data on submit. If this needs
        // to be reflected in the UI, `setValues` can be used in the `onSubmit` prop
        setValues: function setValues(newValues) {
          return _setValues(validateFormDataAgainstFormDefinition(parsedFormDef, newValues));
        }
      });
    },
    onError: function onError() {
      setShowValidationNotice(true);
    },
    children: _jsx(DynamicFormContext.Provider, {
      value: {
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy,
        formId: formId || defaultFormId,
        uploadFile: uploadFile,
        formFileInformation: formFileInformation,
        onChange: onChange,
        onBlur: onBlur,
        debug: debug,
        hideFormInstructions: hideFormInstructions,
        hideFormActions: hideFormActions,
        validationNoticeText: validationNoticeText,
        isSaving: isSaving,
        onAttemptNextWhileVerifying: onAttemptNextWhileVerifying,
        onRequestConfirmPayment: onRequestConfirmPayment,
        onRequestCreateOrder: onRequestCreateOrder,
        onClose: onClose,
        onEvent: onEvent,
        showVerificationOverlayIfNeeded: showVerificationOverlayIfNeeded,
        setShowVerificationOverlayIfNeeded: setShowVerificationOverlayIfNeeded,
        showValidationNotice: showValidationNotice,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        formDefinition: finalFormDef,
        formDataDecisions: formDataDecisions,
        dependencyGraph: dependencyGraph,
        blockProceedWhenMissingFileInfo: blockProceedWhenMissingFileInfo,
        formMetadata: formMetadata,
        setFormMetadata: setFormMetadata,
        request: request,
        initialFormMetadata: initialFormMetadata,
        disabled: disabled
      },
      children: _jsx(PaymentFrameProvider, {
        children: typeof children === 'undefined' ? _jsx(DynamicForm.Form, {
          children: _jsx(DynamicForm.Actions, {})
        }) : children
      })
    })
  });
}
DynamicForm.Form = function DynamicFormForm(_ref4) {
  var noticeText = _ref4.noticeText,
    instructions = _ref4.instructions,
    children = _ref4.children;
  var _useContextOrThrow = useContextOrThrow(DynamicFormContext, 'DynamicForm.Form must be used within a DynamicForm component'),
    ariaLabel = _useContextOrThrow['aria-label'],
    ariaLabelledBy = _useContextOrThrow['aria-labelledby'],
    formId = _useContextOrThrow.formId,
    uploadFile = _useContextOrThrow.uploadFile,
    formFileInformation = _useContextOrThrow.formFileInformation,
    _onChange = _useContextOrThrow.onChange,
    onBlur = _useContextOrThrow.onBlur,
    debug = _useContextOrThrow.debug,
    hideFormInstructions = _useContextOrThrow.hideFormInstructions,
    validationNoticeText = _useContextOrThrow.validationNoticeText,
    onRequestConfirmPayment = _useContextOrThrow.onRequestConfirmPayment,
    onRequestCreateOrder = _useContextOrThrow.onRequestCreateOrder,
    onClose = _useContextOrThrow.onClose,
    onEvent = _useContextOrThrow.onEvent,
    showVerificationOverlayIfNeeded = _useContextOrThrow.showVerificationOverlayIfNeeded,
    setShowVerificationOverlayIfNeeded = _useContextOrThrow.setShowVerificationOverlayIfNeeded,
    showValidationNotice = _useContextOrThrow.showValidationNotice,
    currentPage = _useContextOrThrow.currentPage,
    setCurrentPage = _useContextOrThrow.setCurrentPage,
    formDefinition = _useContextOrThrow.formDefinition,
    formDataDecisions = _useContextOrThrow.formDataDecisions,
    dependencyGraph = _useContextOrThrow.dependencyGraph;
  return _jsx(Form, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    id: formId,
    children: _jsxs(FileProcessingOverlay, {
      showVerificationOverlayIfNeeded: showVerificationOverlayIfNeeded,
      currentPage: currentPage,
      formDefinition: formDefinition,
      formFileInformation: formFileInformation,
      children: [_jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [showValidationNotice && validationNoticeText && _jsx(Notice, {
          intent: "negative",
          children: validationNoticeText
        }), !hideFormInstructions && _jsx(FormInstructions, {
          currentPage: currentPage,
          formDefinition: formDefinition,
          instructions: instructions
        }), formDefinition.components.map(function (component) {
          return _jsx(DynamicField, {
            component: component,
            formDataDecisions: formDataDecisions,
            formDefinition: formDefinition,
            dependencyGraph: dependencyGraph,
            uploadFile: uploadFile,
            formFileInformation: formFileInformation,
            currentPage: currentPage,
            onBlur: onBlur,
            onChange: function onChange(params) {
              setShowVerificationOverlayIfNeeded(false);
              _onChange === null || _onChange === void 0 ? void 0 : _onChange(params);
            },
            onRequestCreateOrder: onRequestCreateOrder,
            onRequestConfirmPayment: onRequestConfirmPayment,
            onClose: onClose,
            onEvent: onEvent
          }, component.key);
        }), _jsx(ConfirmationPage, {
          currentPage: currentPage,
          formDefinition: formDefinition,
          formFileInformation: formFileInformation,
          noticeText: noticeText,
          onEditClick: setCurrentPage
        }), children]
      }), debug && _jsx(Debug, {
        currentPage: currentPage,
        formFileInformation: formFileInformation
      })]
    })
  });
};
DynamicForm.Actions = function DynamicFormActions(_ref5) {
  var submitLabel = _ref5.submitLabel;
  var _useContextOrThrow2 = useContextOrThrow(DynamicFormContext, 'DynamicForm.Actions must be used within a DynamicForm component'),
    formId = _useContextOrThrow2.formId,
    formFileInformation = _useContextOrThrow2.formFileInformation,
    hideFormActions = _useContextOrThrow2.hideFormActions,
    isSaving = _useContextOrThrow2.isSaving,
    onAttemptNextWhileVerifying = _useContextOrThrow2.onAttemptNextWhileVerifying,
    showVerificationOverlayIfNeeded = _useContextOrThrow2.showVerificationOverlayIfNeeded,
    setShowVerificationOverlayIfNeeded = _useContextOrThrow2.setShowVerificationOverlayIfNeeded,
    currentPage = _useContextOrThrow2.currentPage,
    setCurrentPage = _useContextOrThrow2.setCurrentPage,
    formDefinition = _useContextOrThrow2.formDefinition;
  if (hideFormActions) {
    return null;
  }
  return _jsx(FormActions, {
    submitLabel: submitLabel,
    currentPage: currentPage,
    onPageChange: function onPageChange(newPage) {
      setShowVerificationOverlayIfNeeded(false);
      setCurrentPage(newPage);
    },
    formDefinition: formDefinition,
    formFileInformation: formFileInformation,
    isSaving: isSaving,
    onClickNext: function onClickNext() {
      setShowVerificationOverlayIfNeeded(true);
    },
    showVerificationOverlayIfNeeded: showVerificationOverlayIfNeeded,
    onAttemptNextWhileVerifying: onAttemptNextWhileVerifying,
    form: formId
  });
};
export function useIsVerifyingFiles() {
  var _useContextOrThrow3 = useContextOrThrow(DynamicFormContext, 'useIsVerifyingFiles must be used within a DynamicForm component'),
    currentPage = _useContextOrThrow3.currentPage,
    formDefinition = _useContextOrThrow3.formDefinition,
    formFileInformation = _useContextOrThrow3.formFileInformation,
    showVerificationOverlayIfNeeded = _useContextOrThrow3.showVerificationOverlayIfNeeded;
  var _useNeedsVerification = useNeedsVerification({
      currentPage: currentPage,
      formDefinition: formDefinition,
      formFileInformation: formFileInformation
    }),
    needsVerification = _useNeedsVerification.needsVerification;
  return showVerificationOverlayIfNeeded && needsVerification;
}
export function useIsReviewing() {
  var _useContextOrThrow4 = useContextOrThrow(DynamicFormContext, 'useIsReviewing must be used within a DynamicForm component'),
    currentPage = _useContextOrThrow4.currentPage,
    formDefinition = _useContextOrThrow4.formDefinition;
  var fieldValues = useFieldValues();
  var anyFieldsVisible = checkAreAnyFieldsVisible({
    fieldValues: fieldValues,
    currentPage: currentPage,
    formDefinition: formDefinition
  });
  return !anyFieldsVisible;
}

/**
 * Renders an overlay when the user clicks next and there are files that need verification
 */
function FileProcessingOverlay(_ref6) {
  var currentPage = _ref6.currentPage,
    formDefinition = _ref6.formDefinition,
    formFileInformation = _ref6.formFileInformation,
    showVerificationOverlayIfNeeded = _ref6.showVerificationOverlayIfNeeded,
    children = _ref6.children;
  var _useTranslation = useTranslation('DynamicForm'),
    t = _useTranslation.t;
  var _useNeedsVerification2 = useNeedsVerification({
      currentPage: currentPage,
      formDefinition: formDefinition,
      formFileInformation: formFileInformation
    }),
    needsVerification = _useNeedsVerification2.needsVerification,
    estimatedTimeWhenCompleted = _useNeedsVerification2.estimatedTimeWhenCompleted;
  var now = useNow();
  var estimatedTime = estimatedTimeWhenCompleted ? differenceInSeconds(new Date(estimatedTimeWhenCompleted), now) : null;
  return _jsxs(Overlay, {
    disabled: !showVerificationOverlayIfNeeded || !needsVerification,
    children: [children, _jsx(Overlay.Content, {
      children: _jsx("div", {
        style: {
          margin: 'auto',
          width: '240px',
          maxWidth: '100%'
        },
        children: _jsxs(Flex, {
          gap: 6,
          direction: "column",
          align: "center",
          children: [_jsx(Flex, {
            justify: "center",
            children: _jsx(LightBulbAndGearsIllustration, {})
          }), _jsxs(Flex, {
            direction: "column",
            basis: "100%",
            gap: 1,
            children: [_jsx(ProgressIndicator, {
              label: t('validationProgress'),
              variant: "linear",
              indeterminate: true
            }), _jsx(HelpText, {
              children: match(estimatedTime)["with"](null, function () {
                return t('validationHelpTextUnknownEstimate');
              })["with"](P.number.gt(120), function () {
                return t('validationHelpTextLongEstimate');
              })["with"](P.number.gt(0), function () {
                return t('validationHelpTextKnownEstimate', {
                  estimatedTime: estimatedTime
                });
              }).otherwise(function () {
                return t('validationHelpTextExceededEstimate');
              })
            })]
          })]
        })
      })
    })]
  });
}

/**
 * Returns true if the current page has files that need verification
 */
function useNeedsVerification(_ref7) {
  var currentPage = _ref7.currentPage,
    formDefinition = _ref7.formDefinition,
    formFileInformation = _ref7.formFileInformation;
  var fileQuestionKeys = getComponentKeys({
    pageNumber: currentPage,
    formDefinition: formDefinition,
    type: 'file'
  });
  var fieldValues = useFieldValues();
  var needsVerification = false;
  var estimatedTimeWhenCompleted = '';
  var _iterator = _createForOfIteratorHelper(fileQuestionKeys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fileQuestionKey = _step.value;
      var files = fieldValues[fileQuestionKey];
      if (!isArray(files)) {
        continue;
      }
      var _iterator2 = _createForOfIteratorHelper(files),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _fileInfo$validation, _fileInfo$validation2;
          var file = _step2.value;
          var fileId = isFileInfo(file) ? file.id : file;
          if (typeof fileId !== 'string') {
            continue;
          }
          var fileInfo = formFileInformation === null || formFileInformation === void 0 ? void 0 : formFileInformation[fileId];
          if ((fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$validation = fileInfo.validation) === null || _fileInfo$validation === void 0 ? void 0 : _fileInfo$validation.status) === 'in_progress' || (fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$validation2 = fileInfo.validation) === null || _fileInfo$validation2 === void 0 ? void 0 : _fileInfo$validation2.status) === 'pending') {
            needsVerification = true;
            if (fileInfo.validation.estimatedTime && fileInfo.validation.estimatedTime > estimatedTimeWhenCompleted) {
              estimatedTimeWhenCompleted = fileInfo.validation.estimatedTime;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    needsVerification: needsVerification,
    estimatedTimeWhenCompleted: estimatedTimeWhenCompleted
  };
}
function FormActions(_ref8) {
  var form = _ref8.form,
    currentPage = _ref8.currentPage,
    formDefinition = _ref8.formDefinition,
    formFileInformation = _ref8.formFileInformation,
    submitLabel = _ref8.submitLabel,
    onPageChange = _ref8.onPageChange,
    isSaving = _ref8.isSaving,
    onClickNext = _ref8.onClickNext,
    showVerificationOverlayIfNeeded = _ref8.showVerificationOverlayIfNeeded,
    onAttemptNextWhileVerifying = _ref8.onAttemptNextWhileVerifying;
  var _useTranslation2 = useTranslation('DynamicForm'),
    t = _useTranslation2.t;
  var fieldValues = useFieldValues();
  var anyComponentsVisible = checkAreAnyFieldsVisible({
    currentPage: currentPage,
    formDefinition: formDefinition,
    fieldValues: fieldValues
  });
  var nextPage = getNextPageWithVisibleFields({
    currentPage: currentPage,
    fieldValues: fieldValues,
    formDefinition: formDefinition
  });
  var isLastPageBeforeReview = !checkAreAnyFieldsVisible({
    currentPage: nextPage,
    formDefinition: formDefinition,
    fieldValues: fieldValues
  });
  var triggerValidation = useTriggerValidation();
  var _useNeedsVerification3 = useNeedsVerification({
      currentPage: currentPage,
      formDefinition: formDefinition,
      formFileInformation: formFileInformation
    }),
    needsVerification = _useNeedsVerification3.needsVerification;
  var doesCurrentPageHaveFileWarnings = useDoesCurrentPageHaveFileWarnings({
    currentPage: currentPage,
    formDefinition: formDefinition,
    formFileInformation: formFileInformation
  });
  var isSinglePaymentFrame = checkIsSinglePaymentFrame(formDefinition);
  var paymentStatus = usePaymentStatus();
  var _useContextOrThrow5 = useContextOrThrow(DynamicFormContext),
    onClose = _useContextOrThrow5.onClose,
    onEvent = _useContextOrThrow5.onEvent;
  if (isSinglePaymentFrame) {
    return match(paymentStatus)["with"]('creating_order', 'confirming_payment', 'user_paying', function () {
      return null;
    })["with"]('already_paid', 'inactive', 'payment_success', 'unknown_error', function () {
      return _jsx(Flex, {
        grow: 1,
        justify: "end",
        children: _jsx(Button, {
          intent: "primary",
          emphasis: "highlighted",
          onClick: onClose,
          children: t('close')
        })
      });
    }).exhaustive();
  }
  return _jsxs(Flex, {
    gap: 2,
    grow: 1,
    justify: "end",
    children: [currentPage > 1 && _jsx(Button, {
      leadIcon: ArrowLeftOutlineIcon,
      onClick: function onClick() {
        var prevPage = getPrevPageWithVisibleFields({
          currentPage: currentPage,
          fieldValues: fieldValues,
          formDefinition: formDefinition
        });
        onPageChange(prevPage);
      },
      width: "hug",
      intent: "primary",
      emphasis: "highlighted",
      children: t('previous')
    }), anyComponentsVisible && _jsx(Button, {
      trailIcon: ArrowRightOutlineIcon,
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _nextPage;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              onClickNext === null || onClickNext === void 0 ? void 0 : onClickNext();
              if (needsVerification && showVerificationOverlayIfNeeded) {
                onAttemptNextWhileVerifying === null || onAttemptNextWhileVerifying === void 0 ? void 0 : onAttemptNextWhileVerifying();
              }
              _context.next = 4;
              return triggerValidation();
            case 4:
              _context.t0 = _context.sent;
              if (!_context.t0) {
                _context.next = 7;
                break;
              }
              _context.t0 = !needsVerification;
            case 7:
              if (!_context.t0) {
                _context.next = 11;
                break;
              }
              _nextPage = getNextPageWithVisibleFields({
                currentPage: currentPage,
                fieldValues: fieldValues,
                formDefinition: formDefinition
              });
              onPageChange(_nextPage);
              onEvent === null || onEvent === void 0 ? void 0 : onEvent(doesCurrentPageHaveFileWarnings ? 'clicked_proceed' : isLastPageBeforeReview ? 'clicked_review' : 'clicked_next');
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })),
      width: "hug",
      intent: "primary",
      children: doesCurrentPageHaveFileWarnings ? t('proceedAnyway') : isLastPageBeforeReview ? t('review') : t('next')
    }), !anyComponentsVisible && _jsx(Button, {
      type: "submit",
      form: form,
      width: "hug",
      intent: "primary",
      loading: isSaving,
      leadIcon: CheckMarkOutlineIcon,
      children: submitLabel !== null && submitLabel !== void 0 ? submitLabel : t('submit')
    })]
  });
}

/**
 * Returns true if the current page has any file warnings
 */
function useDoesCurrentPageHaveFileWarnings(_ref10) {
  var currentPage = _ref10.currentPage,
    formDefinition = _ref10.formDefinition,
    formFileInformation = _ref10.formFileInformation;
  var fileQuestionKeys = getComponentKeys({
    pageNumber: currentPage,
    formDefinition: formDefinition,
    type: 'file'
  });
  var fieldValues = useFieldValues();
  var _iterator3 = _createForOfIteratorHelper(fileQuestionKeys),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var fileQuestionKey = _step3.value;
      var files = fieldValues[fileQuestionKey];
      if (!isArray(files)) {
        continue;
      }
      var _iterator4 = _createForOfIteratorHelper(files),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _fileInfo$validation3;
          var file = _step4.value;
          var fileId = isFileInfo(file) ? file.id : file;
          if (typeof fileId !== 'string') {
            continue;
          }
          var fileInfo = formFileInformation === null || formFileInformation === void 0 ? void 0 : formFileInformation[fileId];
          if ((fileInfo === null || fileInfo === void 0 ? void 0 : (_fileInfo$validation3 = fileInfo.validation) === null || _fileInfo$validation3 === void 0 ? void 0 : _fileInfo$validation3.status) === 'done' && fileInfo !== null && fileInfo !== void 0 && fileInfo.validation.results.some(function (result) {
            return result.code === 'warning' || result.code === 'negative';
          })) {
            return true;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
}
function FormInstructions(_ref11) {
  var currentPage = _ref11.currentPage,
    formDefinition = _ref11.formDefinition,
    instructions = _ref11.instructions;
  var _useTranslation3 = useTranslation('DynamicForm'),
    t = _useTranslation3.t;
  var fieldValues = useFieldValues();
  var anyFieldsVisible = checkAreAnyFieldsVisible({
    fieldValues: fieldValues,
    currentPage: currentPage,
    formDefinition: formDefinition
  });
  var _usePageProgress = usePageProgress({
      currentPage: currentPage,
      formDefinition: formDefinition
    }),
    completedPageCount = _usePageProgress.completedPageCount,
    visiblePages = _usePageProgress.visiblePages;
  if (checkIsSinglePaymentFrame(formDefinition)) {
    return null;
  }
  var summaryInstructionText = instructions || t('reviewAllProvidedResponses');
  return _jsxs(Flex, {
    gap: 4,
    direction: "column",
    children: [!anyFieldsVisible && _jsx(Text, {
      children: summaryInstructionText
    }), anyFieldsVisible && visiblePages.length > 1 && _jsx(ProgressIndicator, {
      "aria-label": t('progress'),
      variant: "linear",
      value: completedPageCount,
      total: visiblePages.length
    })]
  });
}
function usePageProgress(_ref12) {
  var currentPage = _ref12.currentPage,
    formDefinition = _ref12.formDefinition;
  var fieldValues = useFieldValues();

  // Determine if a the current page has no form fields, eg: a payment prompt
  // in a receipt requirement or a hybrid requirement page with only html elements
  var isCurrentPageReadyOnly = useMemo(function () {
    return formDefinition.components.filter(function (component) {
      var _component$properties;
      return Number((_component$properties = component.properties) === null || _component$properties === void 0 ? void 0 : _component$properties.page) === currentPage;
    }).every(function (component) {
      return component.type === 'htmlelement' || component.type === 'paymentprompt';
    });
  }, [formDefinition, currentPage]);
  var requiredQuestionsForCurrentPage = useMemo(function () {
    return formDefinition.components.filter(function (component) {
      var _component$validate, _component$properties2;
      return isFieldComponent(component) && ((_component$validate = component.validate) === null || _component$validate === void 0 ? void 0 : _component$validate.required) && decideShouldShowField(component, fieldValues) && Number((_component$properties2 = component.properties) === null || _component$properties2 === void 0 ? void 0 : _component$properties2.page) === currentPage;
    });
  }, [formDefinition, fieldValues, currentPage]);
  var answeredRequiredQuestionsForCurrentPage = useMemo(function () {
    return requiredQuestionsForCurrentPage.filter(function (question) {
      return !isEmptyValue(fieldValues[question.key]);
    });
  }, [requiredQuestionsForCurrentPage, fieldValues]);
  var visiblePages = useMemo(function () {
    var visibleFields = formDefinition.components.filter(function (component) {
      return decideShouldShowField(component, fieldValues);
    });
    return uniq(visibleFields.map(function (field) {
      var _field$properties;
      return (_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.page;
    }));
  }, [formDefinition, fieldValues]);
  var actualCurrentPage = visiblePages.indexOf(currentPage.toString()) + 1;
  var completedPageCount = !isCurrentPageReadyOnly && answeredRequiredQuestionsForCurrentPage.length === requiredQuestionsForCurrentPage.length ? actualCurrentPage : actualCurrentPage - 1;
  return {
    visiblePages: visiblePages,
    completedPageCount: completedPageCount
  };
}
function ConfirmationPage(_ref13) {
  var currentPage = _ref13.currentPage,
    formDefinition = _ref13.formDefinition,
    formFileInformation = _ref13.formFileInformation,
    noticeText = _ref13.noticeText,
    onEditClick = _ref13.onEditClick;
  var _useTranslation4 = useTranslation('DynamicForm'),
    t = _useTranslation4.t;
  var _useContextOrThrow6 = useContextOrThrow(DynamicFormContext),
    formMetadata = _useContextOrThrow6.formMetadata;
  var fieldValues = useFieldValues();
  var anyFieldsVisible = checkAreAnyFieldsVisible({
    fieldValues: fieldValues,
    currentPage: currentPage,
    formDefinition: formDefinition
  });
  if (anyFieldsVisible) {
    return null;
  }
  var files = getFormFiles({
    formData: fieldValues,
    formDefinition: formDefinition
  }).map(function (value) {
    if (typeof value === 'string') {
      var _formFileInformation$, _formFileInformation$2, _formFileInformation$3;
      return {
        id: value,
        name: (formFileInformation === null || formFileInformation === void 0 ? void 0 : (_formFileInformation$ = formFileInformation[value]) === null || _formFileInformation$ === void 0 ? void 0 : _formFileInformation$.name) || '',
        validationResults: (formFileInformation === null || formFileInformation === void 0 ? void 0 : (_formFileInformation$2 = formFileInformation[value]) === null || _formFileInformation$2 === void 0 ? void 0 : (_formFileInformation$3 = _formFileInformation$2.validation) === null || _formFileInformation$3 === void 0 ? void 0 : _formFileInformation$3.results.map(function (result) {
          return {
            status: result.code,
            message: result.message
          };
        })) || []
      };
    }
    if (isFileInfo(value)) {
      var _formFileInformation$4, _formFileInformation$5, _formFileInformation$6;
      var fileName = formFileInformation === null || formFileInformation === void 0 ? void 0 : (_formFileInformation$4 = formFileInformation[value.id]) === null || _formFileInformation$4 === void 0 ? void 0 : _formFileInformation$4.name;
      var validationResults = (formFileInformation === null || formFileInformation === void 0 ? void 0 : (_formFileInformation$5 = formFileInformation[value.id]) === null || _formFileInformation$5 === void 0 ? void 0 : (_formFileInformation$6 = _formFileInformation$5.validation) === null || _formFileInformation$6 === void 0 ? void 0 : _formFileInformation$6.results.map(function (result) {
        return {
          status: result.code,
          message: result.message
        };
      })) || [];
      return {
        id: value.id,
        name: fileName || value.file.name,
        validationResults: validationResults
      };
    }
  }).filter(function (item) {
    return !!item;
  });
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(Notice, {
      intent: "primary",
      children: noticeText || t('noticeSubmission')
    }), _jsx(DynamicFormPreview, {
      formDefinition: formDefinition,
      formData: fieldValues,
      formMetadata: formMetadata,
      onEditClick: onEditClick,
      files: files,
      AdditionalFileInformation: FileWarnings
    })]
  });
}
function FileWarnings(_ref14) {
  var file = _ref14.file;
  var warningFiles = file.validationResults.filter(function (result) {
    return result.status === 'negative' || result.status === 'warning';
  });
  return _jsx("div", {
    style: {
      marginTop: '-12px'
    },
    children: _jsx(Flex, {
      direction: "column",
      gap: 2,
      children: warningFiles === null || warningFiles === void 0 ? void 0 : warningFiles.map(function (result, index) {
        return (
          // We always use 'warning' intent regardless of result status,
          // because these do not prevent the user from submitting the form
          _jsx(HelpText, {
            intent: "warning",
            showIcon: true,
            children: result.message
          }, index)
        );
      })
    })
  });
}
function Debug(_ref15) {
  var currentPage = _ref15.currentPage,
    formFileInformation = _ref15.formFileInformation;
  var values = useFieldValues();
  return _jsxs("pre", {
    css: function css(theme) {
      return {
        backgroundColor: theme.colors.bgSecondaryHighlight,
        fontFamily: 'monospace',
        padding: '16px'
      };
    },
    children: ["Debug Info", _jsx("br", {}), "----------", _jsx("br", {}), "Page: ", currentPage, _jsx("br", {}), "Form Values: ", JSON.stringify(values, null, 2), _jsx("br", {}), "Form File Information:", JSON.stringify(formFileInformation, null, 2)]
  });
}
function DynamicField(_ref16) {
  var component = _ref16.component,
    _ref16$formDataDecisi = _ref16.formDataDecisions,
    formDataDecisions = _ref16$formDataDecisi === void 0 ? {} : _ref16$formDataDecisi,
    formDefinition = _ref16.formDefinition,
    dependencyGraph = _ref16.dependencyGraph,
    uploadFile = _ref16.uploadFile,
    formFileInformation = _ref16.formFileInformation,
    currentPage = _ref16.currentPage,
    onBlur = _ref16.onBlur,
    onChange = _ref16.onChange,
    onRequestCreateOrder = _ref16.onRequestCreateOrder,
    onRequestConfirmPayment = _ref16.onRequestConfirmPayment,
    onClose = _ref16.onClose,
    onEvent = _ref16.onEvent;
  var _useTranslation5 = useTranslation('DynamicForm'),
    t = _useTranslation5.t;
  var _useContextOrThrow7 = useContextOrThrow(DynamicFormContext),
    isSaving = _useContextOrThrow7.isSaving,
    blockProceedWhenMissingFileInfo = _useContextOrThrow7.blockProceedWhenMissingFileInfo,
    disabled = _useContextOrThrow7.disabled;
  var directDependencies = useMemo(function () {
    return getConditionalLogicDirectDependencies(component);
  }, [component]);
  var fieldValues = useFieldValues(directDependencies);
  var shouldShowField = useMemo(function () {
    return decideShouldShowField(component, fieldValues);
  }, [component, fieldValues]);
  var setFieldValues = useSetFieldValues();
  var getFieldValues = useGetFieldValues();
  var decisions = formDataDecisions[component.key] || [];
  var overallDecision = decisions.find(function (decision) {
    return decision.type === 'overall';
  });
  var rejectionMessage = overallDecision && isEqual(overallDecision.value, getFieldValues()[component.key]) ? overallDecision.message : null;
  if (!shouldShowField) {
    return null;
  }
  if (getComponentPage(component) !== currentPage) {
    return null;
  }
  var handleChange = function handleChange(value) {
    var newValues = calculateOtherFieldValueUpdates({
      value: value,
      component: component,
      dependencyGraph: dependencyGraph,
      formDefinition: formDefinition,
      oldValues: getFieldValues()
    });
    setFieldValues(_objectSpread(_objectSpread({}, newValues), {}, _defineProperty({}, component.key, value)));
    onChange === null || onChange === void 0 ? void 0 : onChange({
      getValues: getFieldValues,
      setValues: setFieldValues
    });
  };
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    children: [match(component)["with"]({
      type: 'checkbox'
    }, function (component) {
      var _component$validate2;
      return _jsx(Field, {
        as: Checkbox,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate2 = component.validate) !== null && _component$validate2 !== void 0 && _component$validate2.required ? 'This field is required' : false,
        disabled: disabled || component.disabled
      });
    })["with"]({
      type: 'day'
    }, function (component) {
      var _component$validate3;
      return _jsx(Field, {
        as: TimelessDateStringInput,
        name: component.key,
        label: component.label,
        helpText: component.description,
        maxDate: "2100-01-01T00:00:00.000Z",
        minDate: "1900-01-01T00:00:00.000Z",
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate3 = component.validate) !== null && _component$validate3 !== void 0 && _component$validate3.required ? 'This field is required' : false,
        disabled: disabled || component.disabled
      });
    })["with"]({
      type: 'file'
    }, function (component) {
      var _component$validate4, _component$fileTypes, _component$properties3;
      assert(uploadFile, 'uploadFile prop is required when using type=file');
      assert(formFileInformation, 'formFileInformation prop is required when using type=file');
      var noticeText = getFileUploadNoticeText({
        t: t,
        properties: component.properties
      });
      return _jsx(Field, {
        as: CustomFileUpload,
        name: component.key,
        componentKey: component.key,
        label: component.label,
        onBlur: onBlur,
        uploadFile: uploadFile,
        formFileInformation: formFileInformation,
        formDataDecisions: formDataDecisions,
        required: (_component$validate4 = component.validate) !== null && _component$validate4 !== void 0 && _component$validate4.required ? 'This field is required' : false,
        validate: function validate(value) {
          var fileArr = isArray(value) ? value : [];
          var fileInfos = fileArr.filter(isFileInfo);
          var result = validateFiles(fileInfos);
          if (typeof result === 'string') {
            return result;
          }
          if (blockProceedWhenMissingFileInfo) {
            var _iterator5 = _createForOfIteratorHelper(fileArr),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var file = _step5.value;
                if (typeof file === 'string' && !(file in formFileInformation)) {
                  return 'Some files are still processing';
                }
                if (_typeof(file) === 'object' && file && 'id' in file && typeof file.id === 'string' && !(file.id in formFileInformation)) {
                  return 'Some files are still processing';
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
          return true;
        },
        multiple: !!component.multiple,
        disabled: disabled || component.disabled,
        onChange: handleChange,
        allowedFileTypes: (_component$fileTypes = component.fileTypes) === null || _component$fileTypes === void 0 ? void 0 : _component$fileTypes.map(function (fileType) {
          return fileType.value;
        }),
        maxFileSize: component.fileMaxSize,
        maxNumberOfFiles: (_component$properties3 = component.properties) === null || _component$properties3 === void 0 ? void 0 : _component$properties3.fileMaxCount,
        isSaving: !!isSaving,
        notice: noticeText ? _jsx(Notice, {
          children: noticeText
        }) : undefined,
        onEvent: onEvent
      });
    })["with"]({
      type: 'number'
    }, function (component) {
      var _component$validate5, _component$validate6, _component$validate7;
      return _jsx(Field, {
        as: NumberInput,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate5 = component.validate) !== null && _component$validate5 !== void 0 && _component$validate5.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        min: (_component$validate6 = component.validate) === null || _component$validate6 === void 0 ? void 0 : _component$validate6.min,
        max: (_component$validate7 = component.validate) === null || _component$validate7 === void 0 ? void 0 : _component$validate7.max,
        validate: function validate(value) {
          var _component$validate8, _component$validate10;
          if (Number(value) > Number((_component$validate8 = component.validate) === null || _component$validate8 === void 0 ? void 0 : _component$validate8.max)) {
            var _component$validate9;
            return "This value can't be greater than ".concat((_component$validate9 = component.validate) === null || _component$validate9 === void 0 ? void 0 : _component$validate9.max);
          }
          if (Number(value) < Number((_component$validate10 = component.validate) === null || _component$validate10 === void 0 ? void 0 : _component$validate10.min)) {
            var _component$validate11;
            return "This value can't be less than ".concat((_component$validate11 = component.validate) === null || _component$validate11 === void 0 ? void 0 : _component$validate11.min);
          }
          return true;
        }
      });
    })["with"]({
      type: 'radio'
    }, function (component) {
      var _component$validate12;
      return _jsx(Field, {
        as: RadioGroup,
        name: component.key,
        onBlur: onBlur,
        onChange: handleChange,
        label: component.label,
        helpText: component.description,
        required: (_component$validate12 = component.validate) !== null && _component$validate12 !== void 0 && _component$validate12.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        children: component.values.map(function (_ref17) {
          var label = _ref17.label,
            value = _ref17.value;
          return _jsx(RadioGroup.Option, {
            label: label,
            value: value
          }, value);
        })
      });
    })["with"]({
      type: 'select',
      data: {
        url: P.string
      }
    }, function (component) {
      return _jsx(DynamicSelect, {
        component: component,
        onChange: handleChange,
        onBlur: onBlur
      });
    })["with"]({
      type: 'select',
      searchEnabled: true
    }, function (component) {
      var _component$validate13;
      return _jsx(Field, {
        as: Combobox,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate13 = component.validate) !== null && _component$validate13 !== void 0 && _component$validate13.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        filterOption: function filterOption(option, query) {
          return option.label.toLowerCase().includes(query.trim().toLowerCase());
        },
        children: component.data.values.map(function (value) {
          return _jsx(Combobox.Option, {
            label: value.label,
            value: value.value
          }, value.value);
        })
      });
    })["with"]({
      type: 'select'
    }, function (component) {
      var _component$validate14;
      return _jsx(Field, {
        as: Select,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate14 = component.validate) !== null && _component$validate14 !== void 0 && _component$validate14.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        appearance: "styled",
        children: component.data.values.map(function (value) {
          return _jsx(Select.Option, {
            label: value.label,
            value: value.value
          }, value.value);
        })
      });
    })["with"]({
      type: 'selectboxes'
    }, function (component) {
      var _component$validate15, _component$values;
      return _jsx(Field, {
        as: CheckboxGroup,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate15 = component.validate) !== null && _component$validate15 !== void 0 && _component$validate15.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        children: (_component$values = component.values) === null || _component$values === void 0 ? void 0 : _component$values.map(function (value) {
          return _jsx(CheckboxGroup.Option, {
            label: value.label,
            value: value.value
          }, value.value);
        })
      });
    })["with"]({
      type: 'textarea'
    }, function (component) {
      var _component$validate16;
      return _jsx(Field, {
        as: Textarea,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate16 = component.validate) !== null && _component$validate16 !== void 0 && _component$validate16.required ? 'This field is required' : false,
        validate: validateTextComponent(component.validate),
        disabled: disabled || component.disabled
      });
    })["with"]({
      type: 'textfield'
    }, function (component) {
      var _component$validate17;
      return _jsx(Field, {
        as: TextInput,
        name: component.key,
        label: component.label,
        helpText: component.description,
        onBlur: onBlur,
        onChange: handleChange,
        required: (_component$validate17 = component.validate) !== null && _component$validate17 !== void 0 && _component$validate17.required ? 'This field is required' : false,
        disabled: disabled || component.disabled,
        validate: validateTextComponent(component.validate)
      });
    })["with"]({
      type: 'htmlelement',
      tag: 'a'
    }, function (component) {
      var htmlElementAttrs = {};
      component.attrs.forEach(function (attribute) {
        htmlElementAttrs[attribute.attr] = attribute.value;
      });
      return _jsx(Flex, {
        children: _jsx(Link, {
          href: htmlElementAttrs.href,
          variant: "standalone",
          mode: htmlElementAttrs.target === '_blank' ? 'override_user_choice_and_open_in_new_tab' : undefined,
          children: component.content
        })
      });
    })["with"]({
      type: 'htmlelement',
      tag: 'p'
    }, function (component) {
      return _jsx(Text, {
        as: "p",
        children: component.content
      });
    })["with"]({
      type: 'htmlelement',
      tag: 'div'
    }, function (component) {
      return _jsx(Markdown, {
        headingSettings: {
          baseLevel: 1,
          maxLevel: 0
        },
        markdown: component.content
      });
    })["with"]({
      type: 'paymentprompt'
    }, function (component) {
      return _jsx(PaymentPrompt, {
        paymentLink: component.properties.paymentLink,
        onEvent: onEvent
      });
    })["with"]({
      type: 'paymentframe'
    }, function () {
      assert(onRequestCreateOrder, 'onRequestCreateOrder prop is required when using type=paymentframe');
      assert(onRequestConfirmPayment, 'onRequestConfirmPayment prop is required when using type=paymentframe');
      assert(onClose, 'onClose prop is required when using type=paymentframe');
      return _jsx(PaymentFrame, {
        onRequestCreateOrder: onRequestCreateOrder,
        onRequestConfirmPayment: onRequestConfirmPayment,
        onCancelPayment: function onCancelPayment() {
          onEvent === null || onEvent === void 0 ? void 0 : onEvent('cancel_payment');
          onClose();
        }
      });
    }).exhaustive(), rejectionMessage && _jsx(RejectionMessage, {
      message: rejectionMessage
    })]
  });
}
function getFileUploadNoticeText(_ref18) {
  var properties = _ref18.properties,
    t = _ref18.t;
  if (!(properties !== null && properties !== void 0 && properties.requiresNotarization) && !(properties !== null && properties !== void 0 && properties.requiresPlagiarismCheck)) {
    return;
  }
  if (properties.requiresNotarization && !properties.requiresPlagiarismCheck) {
    return t('noticeNotarization');
  }
  if (!properties.requiresNotarization && properties.requiresPlagiarismCheck) {
    return t('noticePlagiarismCheck');
  }
  return t('noticePlagiarismAndNotarization');
}
export var RejectionMessage = function RejectionMessage(_ref19) {
  var message = _ref19.message;
  return _jsx("div", {
    css: function css(theme) {
      return {
        borderLeft: "4px solid ".concat(theme.colors.iconNegative),
        paddingTop: theme.spacing[2],
        paddingBottom: theme.spacing[2]
      };
    },
    children: _jsx(Box, {
      pl: 3,
      children: _jsx(Text, {
        variant: "bodyM",
        children: message
      })
    })
  });
};
function WarningMessage(_ref20) {
  var _fileInformation$vali;
  var fileInformation = _ref20.fileInformation;
  var _useTranslation6 = useTranslation('DynamicForm'),
    t = _useTranslation6.t;
  useDynamicFormViewEvent({
    event: 'view_file_warning'
  });
  var listLabelId = useId();
  var warnings = fileInformation === null || fileInformation === void 0 ? void 0 : (_fileInformation$vali = fileInformation.validation) === null || _fileInformation$vali === void 0 ? void 0 : _fileInformation$vali.results.filter(function (result) {
    return result.code === 'warning';
  });
  assert(warnings === null || warnings === void 0 ? void 0 : warnings.length, 'Could not find warnings in validation results');
  return _jsx(Flex, {
    direction: "column",
    children: warnings.length > 1 ? _jsxs(_Fragment, {
      children: [_jsx(HelpText, {
        id: listLabelId,
        intent: "warning",
        children: t('multipleFileWarnings')
      }), _jsx("ul", {
        "aria-labelledby": listLabelId,
        css: function css(theme) {
          return {
            listStyle: 'disc',
            paddingLeft: theme.spacing[6],
            color: theme.colors.textWarning
          };
        },
        children: warnings.map(function (warning, index) {
          return _jsx("li", {
            children: _jsx(HelpText, {
              intent: "warning",
              children: warning.message
            })
          }, index);
        })
      })]
    }) : _jsx(HelpText, {
      intent: "warning",
      children: warnings[0].message
    })
  });
}

/**
 * A custom file upload that is exactly like the crystal file upload, except
 * that the value is Array<string | FileInfo> instead of Array<FileInfo>
 *
 * This is for convenience, since our backend and our agreed upon dynamic form
 * schema expects files to be an array of file IDs
 *
 * By the time the form is submitted, all files should be uploaded and all
 * elements in the array should be strings
 */
function CustomFileUpload(_ref21) {
  var _value$filter;
  var _ref21$value = _ref21.value,
    value = _ref21$value === void 0 ? [] : _ref21$value,
    _onChange2 = _ref21.onChange,
    formFileInformation = _ref21.formFileInformation,
    componentKey = _ref21.componentKey,
    formDataDecisions = _ref21.formDataDecisions,
    isSaving = _ref21.isSaving,
    label = _ref21.label,
    notice = _ref21.notice,
    required = _ref21.required,
    onEvent = _ref21.onEvent,
    otherProps = _objectWithoutProperties(_ref21, _excluded);
  var _useTranslation7 = useTranslation('DynamicForm'),
    t = _useTranslation7.t;
  var labelId = useId();
  var noticeId = useId();
  var transformedValue = ((_value$filter = value.filter(function (value) {
    var _formFileInformation$7;
    if (typeof value === 'string' && formFileInformation && formFileInformation[value] && (_formFileInformation$7 = formFileInformation[value]) !== null && _formFileInformation$7 !== void 0 && _formFileInformation$7.deleted) {
      var fileInfo = formFileInformation[value];
      assert((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.deleted) && (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.deletionReason) === 'pii', 'Unexpected deletion reason');
      return !fileInfo.deleted;
    }
    return true;
  })) === null || _value$filter === void 0 ? void 0 : _value$filter.map(function (value) {
    if (typeof value === 'string') {
      var _formFileInformation$8, _formFileInformation$9, _formFileInformation$10, _formFileInformation$11;
      return {
        id: value,
        file: new File(['dummyText'], ((_formFileInformation$8 = formFileInformation[value]) === null || _formFileInformation$8 === void 0 ? void 0 : _formFileInformation$8.name) || 'unknown'),
        warningMessage: (_formFileInformation$9 = formFileInformation[value]) === null || _formFileInformation$9 === void 0 ? void 0 : (_formFileInformation$10 = _formFileInformation$9.validation) === null || _formFileInformation$10 === void 0 ? void 0 : (_formFileInformation$11 = _formFileInformation$10.results.find(function (_ref22) {
          var code = _ref22.code;
          return code === 'warning';
        })) === null || _formFileInformation$11 === void 0 ? void 0 : _formFileInformation$11.message
      };
    }
    if (isFileInfo(value)) {
      var _formFileInformation$12, _formFileInformation$13, _formFileInformation$14;
      return _objectSpread(_objectSpread({}, value), {}, {
        warningMessage: (_formFileInformation$12 = formFileInformation[value.id]) === null || _formFileInformation$12 === void 0 ? void 0 : (_formFileInformation$13 = _formFileInformation$12.validation) === null || _formFileInformation$13 === void 0 ? void 0 : (_formFileInformation$14 = _formFileInformation$13.results.find(function (_ref23) {
          var code = _ref23.code;
          return code === 'warning';
        })) === null || _formFileInformation$14 === void 0 ? void 0 : _formFileInformation$14.message
      });
    }
    return value;
  }).filter(Boolean)) || [];
  var deletedFileCount = Object.values(value).length - transformedValue.length;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [notice && _jsxs(_Fragment, {
      children: [_jsxs(Text, {
        variant: "labelM",
        id: labelId,
        children: [label, required && _jsx(Text, {
          as: "span",
          variant: "labelM",
          intent: "negative",
          contrast: "mid",
          children: _jsx("span", {
            "aria-hidden": true,
            children: " *"
          })
        })]
      }), _jsx("div", {
        id: noticeId,
        children: notice
      })]
    }), _jsx(FileUpload, _objectSpread(_objectSpread({
      "aria-describedby": notice ? noticeId : undefined,
      "aria-labelledby": notice ? labelId : undefined,
      label: notice ? undefined : label,
      value: transformedValue,
      onChange: function onChange(newValue) {
        if (transformedValue.some(function (file) {
          return file.warningMessage;
        })) {
          onEvent === null || onEvent === void 0 ? void 0 : onEvent('uploaded_new_file_to_file_with_warning');
        }
        _onChange2(newValue);
      },
      required: required
    }, otherProps), {}, {
      children: _jsxs(FileUpload.FileList, {
        children: [_jsx(FileList, {
          maxItems: 4,
          orientation: "vertical",
          children: transformedValue.map(function (file, index) {
            var _formDataDecisions$co;
            var negativeDecision = (_formDataDecisions$co = formDataDecisions[componentKey]) === null || _formDataDecisions$co === void 0 ? void 0 : _formDataDecisions$co.find(function (decision) {
              return decision.status === 'rejected' && decision.type === 'per_item' && decision.item === file.id;
            });
            return _jsx(FileList.Item, {
              name: file.file.name,
              value: index.toString(),
              intent: file.errorMessage || negativeDecision ? 'negative' : file.warningMessage ? 'warning' : undefined,
              helpText: negativeDecision ? _jsx(RejectionMessage, {
                message: negativeDecision.message
              }) : file.errorMessage || (file.warningMessage ? _jsx(WarningMessage, {
                fileInformation: formFileInformation[file.id]
              }) : undefined),
              uploading: file.uploading || !(file.id in formFileInformation) && isSaving,
              onRemove: function onRemove() {
                if (file.warningMessage) {
                  onEvent === null || onEvent === void 0 ? void 0 : onEvent('removed_file_with_warning');
                }
                _onChange2(transformedValue.filter(function (_, i) {
                  return i.toString() !== index.toString();
                }));
              }
            }, index);
          })
        }), deletedFileCount > 0 && _jsx(Flex, {
          gap: 2,
          pt: 3,
          children: _jsx(HelpText, {
            intent: "warning",
            showIcon: true,
            children: t('documentsDeletedDueToPII', {
              count: deletedFileCount
            })
          })
        })]
      })
    }))]
  });
}

/**
 * Validates that
 *
 */
function validateTextComponent(validate) {
  return function (fieldValue) {
    if (validate !== null && validate !== void 0 && validate.required && !fieldValue.trim().length) {
      return 'This field is required';
    }
    if (validate && 'pattern' in validate) {
      return validatePattern(validate === null || validate === void 0 ? void 0 : validate.pattern)(fieldValue);
    }
    return true;
  };
}
function validatePattern(pattern) {
  return function (fieldValue) {
    if (!pattern || !(fieldValue !== null && fieldValue !== void 0 && fieldValue.length)) {
      return true;
    }
    return RegExp(pattern).test(fieldValue) ? true : 'Invalid format';
  };
}
function processFormDataForSubmit(_ref24) {
  var formDefinition = _ref24.formDefinition,
    formData = _ref24.formData;
  var trimmedValues = trimTextComponentValues({
    formDefinition: formDefinition,
    formData: formData
  });
  return convertFileValuesToIds({
    formDefinition: formDefinition,
    formData: trimmedValues
  });
}

/**
 * Trims whitespace from textfield and textarea type components
 * Some BE endpoints throw an exception when receiving a whitepsace-only string like ' '
 * This should only apply to optional fields since the DynamicForm treats required
 * text fields with only whitespace as invalid and prevents advancing/submitting
 */
function trimTextComponentValues(_ref25) {
  var formDefinition = _ref25.formDefinition,
    formData = _ref25.formData;
  var trimmedValues = {};
  var _loop = function _loop(key) {
    var currentValue = formData[key];
    var component = formDefinition.components.find(function (component) {
      return component.key === key;
    });
    assert(component, "Cannot find component with key: ".concat(key));
    if (component.type === 'textarea' || component.type === 'textfield') {
      trimmedValues[key] = typeof currentValue === 'string' ? currentValue.trim() : currentValue;
    } else {
      trimmedValues[key] = currentValue;
    }
  };
  for (var key in formData) {
    _loop(key);
  }
  return trimmedValues;
}

/**
 * In some cases, like when uploading a file directly to S3, we keep the FileInfo object
 * as the field value and can't rely on the formFileInformation prop. In this case, we need to
 * process the field value and convert it to an array of ids before submitting
 */
export function convertFileValuesToIds(_ref26) {
  var formDefinition = _ref26.formDefinition,
    formData = _ref26.formData;
  if (!formDefinition.components.filter(function (component) {
    return component.type === 'file';
  }).length) {
    return formData;
  }
  var processedValues = {};
  var _loop2 = function _loop2(key) {
    var component = formDefinition.components.find(function (component) {
      return component.key === key;
    });
    var currentValue = formData[key];
    if ((component === null || component === void 0 ? void 0 : component.type) === 'file' && isArray(currentValue)) {
      processedValues[key] = currentValue.map(function (value) {
        if (isFileInfo(value)) {
          return value.id;
        }
        return value;
      });
    } else {
      processedValues[key] = currentValue;
    }
  };
  for (var key in formData) {
    _loop2(key);
  }
  return processedValues;
}
function getFormFiles(_ref27) {
  var formData = _ref27.formData,
    formDefinition = _ref27.formDefinition;
  var fileComponents = formDefinition.components.filter(function (component) {
    return component.type === 'file';
  });
  return fileComponents.map(function (component) {
    return formData[component.key];
  }).flat();
}
export function useResetForm() {
  var reset = useResetFormValues();
  var _useContextOrThrow8 = useContextOrThrow(DynamicFormContext, 'useResetForm must be used within a DynamicForm component'),
    setCurrentPage = _useContextOrThrow8.setCurrentPage,
    formDefinition = _useContextOrThrow8.formDefinition,
    formDataDecisions = _useContextOrThrow8.formDataDecisions,
    setFormMetadata = _useContextOrThrow8.setFormMetadata,
    initialFormMetadata = _useContextOrThrow8.initialFormMetadata;
  var resetPaymentFrame = useResetPaymentFrame();
  return function () {
    batch(function () {
      resetPaymentFrame();
      setCurrentPage(getInitialPageToDisplay(formDefinition.components, formDataDecisions));
      reset();
      setFormMetadata(initialFormMetadata || {});
    });
  };
}
function DynamicSelect(_ref28) {
  var _formMetadata$selectD, _component$validate18;
  var component = _ref28.component,
    _onChange3 = _ref28.onChange,
    onBlur = _ref28.onBlur;
  var _useContextOrThrow9 = useContextOrThrow(DynamicFormContext),
    formMetadata = _useContextOrThrow9.formMetadata,
    setFormMetadata = _useContextOrThrow9.setFormMetadata,
    _useContextOrThrow9$r = _useContextOrThrow9.request,
    request = _useContextOrThrow9$r === void 0 ? defaultRequest : _useContextOrThrow9$r,
    disabled = _useContextOrThrow9.disabled;
  var _useDebouncedState = useDebouncedState(''),
    _useDebouncedState2 = _slicedToArray(_useDebouncedState, 3),
    searchQuery = _useDebouncedState2[0],
    debouncedSearchQuery = _useDebouncedState2[1],
    setSearchQuery = _useDebouncedState2[2];
  var url = useMemo(function () {
    return mergeQueryParams(component.data.url, _defineProperty({}, component.searchField, debouncedSearchQuery));
  }, [component.data.url, component.searchField, debouncedSearchQuery]);
  var debouncing = searchQuery !== debouncedSearchQuery;
  var _useQuery = useQuery(['DynamicForm/DynamicSelect', {
      pkg: 'ab-application',
      url: url
    }], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var json, dataPath, arr;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (debouncedSearchQuery) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", []);
          case 2:
            _context2.next = 4;
            return request(url);
          case 4:
            json = _context2.sent;
            dataPath = component.selectValues;
            arr = dataPath ? get(json, dataPath) : json;
            assert(isArray(arr), 'Expected an array of objects');
            return _context2.abrupt("return", arr);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))),
    data = _useQuery.data,
    isLoading = _useQuery.isLoading,
    isError = _useQuery.isError;
  var selectedItem = formMetadata === null || formMetadata === void 0 ? void 0 : (_formMetadata$selectD = formMetadata.selectData) === null || _formMetadata$selectD === void 0 ? void 0 : _formMetadata$selectD[component.key];
  var selectedItemValue = selectedItem && get(selectedItem, component.valueProperty);
  if (selectedItem) {
    assert(typeof selectedItemValue === 'string');
  }
  var selectedItemIsInData = !!(data !== null && data !== void 0 && data.find(function (item) {
    return get(item, component.valueProperty) === selectedItemValue;
  }));
  return _jsxs(_Fragment, {
    children: [_jsxs(Field, {
      as: Combobox,
      name: component.key,
      label: component.label,
      helpText: component.description,
      onBlur: onBlur,
      onChange: function onChange(newValue) {
        if (!newValue) {
          setFormMetadata(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              selectData: omit(prev.selectData, component.key)
            });
          });
          return;
        }
        var item = data === null || data === void 0 ? void 0 : data.find(function (item) {
          return get(item, component.valueProperty) === newValue;
        });
        assert(item);
        setFormMetadata(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            selectData: _objectSpread(_objectSpread({}, prev.selectData), {}, _defineProperty({}, component.key, item))
          });
        });
        _onChange3(newValue);
      },
      required: (_component$validate18 = component.validate) !== null && _component$validate18 !== void 0 && _component$validate18.required ? 'This field is required.  Please select one of the options from the dropdown' : false,
      disabled: disabled || component.disabled,
      onSearch: setSearchQuery,
      filterOption: function filterOption(option) {
        return option.label.toLowerCase().includes(debouncedSearchQuery.trim().toLowerCase());
      },
      enforceNoMissingOption: true,
      loading: isLoading || debouncing,
      intent: isError ? 'negative' : undefined,
      children: [typeof selectedItemValue === 'string' && !selectedItemIsInData && _jsx(Combobox.Option, {
        label: Mustache.render(component.template, {
          item: selectedItem
        }),
        value: selectedItemValue
      }, selectedItemValue), data === null || data === void 0 ? void 0 : data.map(function (item) {
        var value = get(item, component.valueProperty);
        assert(typeof value === 'string', 'Expected value to be a string');
        return _jsx(Combobox.Option, {
          value: value,
          label: Mustache.render(component.template, {
            item: item
          })
        }, value);
      })]
    }), isError && _jsx(HelpText, {
      intent: "negative",
      showIcon: true,
      children: "An error ocurred searching options. Please try again later"
    })]
  });
}
function defaultRequest(_x) {
  return _defaultRequest.apply(this, arguments);
}
function _defaultRequest() {
  _defaultRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
    var res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fetch(url);
        case 2:
          res = _context3.sent;
          assert(res.status === 200, 'Failed to fetch data');
          return _context3.abrupt("return", res.json());
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _defaultRequest.apply(this, arguments);
}
function mergeQueryParams(urlStr, queryParams) {
  var isRelative = urlStr.startsWith('/');
  var url = isRelative ? new URL("http://localhost".concat(urlStr)) : new URL(urlStr);
  var searchParams = new URLSearchParams(url.search);
  for (var _i = 0, _Object$entries = Object.entries(queryParams); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    searchParams.set(key, value);
  }
  url.search = searchParams.toString();
  if (isRelative) {
    return url.toString().replace('http://localhost', '');
  }
  return url.toString();
}
export function useDynamicFormViewEvent(_ref30) {
  var event = _ref30.event;
  var _useContextOrThrow10 = useContextOrThrow(DynamicFormContext, 'useDynamicFormViewEvent must be used within a DynamicForm component'),
    onEvent = _useContextOrThrow10.onEvent;
  var didTrackRef = React.useRef(false);

  // eslint-disable-next-line no-restricted-syntax -- Need useEffect to run event when component is displayed
  useEffect(function () {
    if (!didTrackRef.current) {
      onEvent === null || onEvent === void 0 ? void 0 : onEvent(event);
      didTrackRef.current = true;
    }
  }, [onEvent, event]);
}